import React from 'react';
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'

import { Flex } from 'reflexbox'
import FontIcon from 'react-toolbox/lib/font_icon'
import cn from 'classnames'
import PropTypes from 'prop-types'; 

const CollapsableOverlay = (props) => {

    const { toggleCollapseFunc, collapse } = props
    const msg = collapse ? 'Show Less' : 'Show More'
    const icon = collapse ? 'expand_less' : 'expand_more'
    const overlayStyle = collapse ? styles.collapseOverlay : styles.notCollapseOverlay

    return(
        <Flex className={cn(styles.showMoreOverlay, overlayStyle)} justify='center' align='center'>
            <Flex className={styles.showMore} onClick={toggleCollapseFunc}>
                <FontIcon
                    className={styles.icon}
                    value={icon}
                    />
                <span>{msg}</span>
                <div className={styles.empty}/>
            </Flex>
        </Flex>
    )
}

CollapsableOverlay.propTypes = {
    toggleCollapseFunc: PropTypes.func.isRequired,
    collapse: PropTypes.bool.isRequired,
};

const withStyles = CSSModules(styles);
export default withStyles(CollapsableOverlay);